module.exports = __webpack_public_path__ + "static/media/activity icon 2.dc9b46b3.svg";